import React, { useState, useEffect, useCallback } from "react";
import DesktopView from "../layout/DesktopView";
import CoreModelCard from "./CoreModelCard";
import { getCoreModels } from "../../services/coreModelService";
import { useToast } from "../common/ToastContext";

const CoreModelDesktop = () => {
  const [models, setModels] = useState([]);
  const { showToast } = useToast();

  const fetchModels = useCallback(async () => {
    try {
      const fetchedModels = await getCoreModels();
      const sortedModels = fetchedModels.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setModels(sortedModels);
    } catch (error) {
      console.error("Error fetching models:", error);
      showToast("Failed to fetch models", "error");
    }
  }, [showToast]);

  useEffect(() => {
    fetchModels();
  }, [fetchModels]);

  const handleSearch = (term) => {
    // This function is left empty as search is handled internally by DesktopView
  };

  const handleModelClick = (model) => {
    // Implement if you want to do something when a model is clicked
  };

  // Implement these functions if you need them
  const handleSaveModel = async (modelData) => {
    // Implement save logic
  };

  const handleDeleteModel = async (modelId) => {
    // Implement delete logic
  };

  const handleResetModel = async (modelId) => {
    // Implement reset logic if needed
  };

  const handleCloseModelEditor = () => {
    // Implement close editor logic if needed
  };

  const handleAddNewModel = async () => {
    // Implement add new model logic
  };

  return (
    <DesktopView
      items={models}
      selectedItem={null}
      onSearch={handleSearch}
      searchPlaceholder="Filter models ..."
      contextMenuItems={[]}
      onItemClick={handleModelClick}
      onSave={handleSaveModel}
      onDelete={handleDeleteModel}
      onReset={handleResetModel}
      onClose={handleCloseModelEditor}
      Card={CoreModelCard}
      Editor={null}
      addNewItem={handleAddNewModel}
      eventName="modelCreated"
    />
  );
};

export default CoreModelDesktop;
